module.exports = __webpack_public_path__ + "img/00035.1615e6c7.webp";